import React, {useState, useCallback, useEffect} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import useActiveTabIndicator from "hooks/useActiveTabIndicator";

function Tabs({children}) {
    const pathname = useLocation().pathname.split('/')[2];
    const [activeTab, setActiveTab] = useState(pathname);
    const handleActiveTab = useCallback(label => setActiveTab(label), [])
    const navigate = useNavigate()
    const {listRef, registerTab, indicator} = useActiveTabIndicator(
        activeTab,
        children.map(child => child.props.label),
    )
    // Once the sliding bar is measured, the active tab keeps a transparent
    // border so its height, and the content below, do not move.
    const activeUnderline = indicator ? 'border-b-2 border-b-transparent' : 'border-b-2 border-b-yellow-500'

    const tabs = children.map(child => (

        <div onClick={e => {
            e.preventDefault()
            handleActiveTab(child.props.label)
            navigate(`./${child.props.label}`,{replace:true})
        }}
             ref={registerTab(child.props.label)}
             className={`inline-block  py-3 px-4 cursor-pointer transition-colors duration-150 ${child.props.label === activeTab ? `${activeUnderline} text-yellow-500` : 'hover:border-b-2 hover:border-b-gray-500'}`}
             key={child.props.label}>
            {child.props.tabName}
        </div>
    ))

    const tabContent = children.filter(child => child.props.label === activeTab)
    return (
        <div>
            <div ref={listRef} className='relative ml-3 flex gap-4  bg-white border-b-0 border-gray-100'>
                {tabs}
                {indicator && (
                    <span
                        data-testid="tab-indicator"
                        aria-hidden="true"
                        className="pointer-events-none absolute bottom-0 h-0.5 bg-yellow-500 motion-safe:transition-[left,width] motion-safe:duration-[250ms] motion-safe:ease-[cubic-bezier(0.22,1,0.36,1)]"
                        style={{left: indicator.left, width: indicator.width}}
                    />
                )}
            </div>
            <div className=''>{tabContent}</div>
        </div>
    )
}

function Tab(props) {
    return <>{props.children}</>
}

export {Tabs, Tab}